// 设置用户登录信息
export const SET_USER_LOGIN_INFO = (state, data) => {
  state.userInfo = data;
};

// 设置加载状态
export const SET_LOAD_STATUS = (state, status) => {
  state.isLoading = status;
};

// 设置内容列表
export const SET_CONTENT_LIST = (state, data) => {
  state.contentList = data;
};

// 设置轮播图
export const SET_BANNER_LIST = (state, data) => {
  state.bannerList = data;
};

// 设置筛选分类
export const SET_CLASSIFY_LIST = (state, data) => {
  state.classifyList = data;
};

// 设置商品列表(搜索)
export const SET_SEARCH_GOODS_LIST = (state, data) => {
  state.searchGoodsList = data;
};

// 设置商品列表(分类搜索)
export const SET_GOODS_LIST = (state, data) => {
  state.goodsList = data;
};

// 设置父类ID
export const SET_CURRENT_CLASSIFY_ID = (state, data) => {
  state.currentClassifyId = data;
};

// 设置商品详细信息
export const SET_GOODS_INFO = (state, data) => {
  state.goodsInfo = data;
};

// 设置首页推荐列表
export const SET_HOME_LIST = (state, data) => {
  state.homeList = data;
};




// WEBPACK FOOTER //
// ./src/store/mutations.js